import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { fetchPincodeDetails, getChoiceMasters } from "../../services/apiservice"
import * as lookup from "../../../static/lookup.json"
import * as sectionKeysToCheckNegativePincode from "../../../static/sectionKeysToCheckForNegativePincode.json"
import { getValueFromJourney, feetToCms } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import { JourneyContext } from "../context/journeyContext";
import { isIE } from 'react-device-detect';

const NumberContainer = styled.div`
  display: block;
  margin: 13px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;

    & > input {
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);
    }
  }
  
`

// Helper functions for universal validation
const isPhoneNumberField = (formControlKey) => {
  if (!formControlKey) return false
  const key = formControlKey.toLowerCase()
  return key.includes("contact") || key.includes("mobile") || key.includes("phone")
}

const isPincodeField = (formControlKey) => {
  if (!formControlKey) return false
  return formControlKey.toLowerCase().includes("pincode")
}

const getCountryFieldForSection = (sectionId, formControlKey, sectionData) => {
  // For appointeePincode, check appointeeCountry (only when appointeeAddressSameAsLaOthers is "Others")
  if (formControlKey && formControlKey.toLowerCase().includes("appointee") && formControlKey.toLowerCase().includes("pincode")) {
    const addressSameAs = sectionData?.["appointeeAddressSameAsLaOthers"]
    if (addressSameAs === "Others" && sectionData?.["appointeeCountry"]) {
      return "appointeeCountry"
    }
  }
  
  // Common country field patterns
  const countryFields = [
    "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
    "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
    "jointlifePermanentAddressCountry", "eaCountry"
  ]
  
  // Try to find country field in section data
  for (const field of countryFields) {
    if (sectionData && sectionData[field]) {
      return field
    }
  }
  
  // Section-specific mappings
  const sectionCountryMap = {
    "SectionCommonResidenceAndOccupation": "countryofbirth",
    "proposerCommonResidenceAndOccupation": "proposerCountry",
    "SectionFlexiEdgeFillProposalPersonalDetail": "currentCountryofResidence",
    "SectionFlexiEdgeFillProposalProposerDetails": "proposerCountry",
    "FutureDollarGiftCityPersonelDetailsSection": "GIFTcountry",
    "SectionFlexiEdgeFillproposalOccupationDetails": "country",
    "FlexiEdgeFillProposalAppointeeSection": "appointeeCountry"
  }
  
  return sectionCountryMap[sectionId] || "country"
}

const updatePhoneValidation = (journeySteps, pageId, sectionId, componentId, formControlKey, isIndia) => {
  try {
    const tempPageIndex = journeySteps.pages.findIndex(page => page.pageId === pageId)
    if (tempPageIndex === -1) return false
    
    const tempSectionIndex = journeySteps.pages[tempPageIndex].sections.findIndex(section => section.sectionId === sectionId)
    if (tempSectionIndex === -1) return false
    
    const tempComponentGroupIndex = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(cg => cg.componentId === componentId)
    if (tempComponentGroupIndex === -1) return false
    
    const tempComponentIndex = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(comp => comp.formControlKey === formControlKey)
    if (tempComponentIndex === -1) return false
    
    const component = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]
    
    if (isIndia) {
      component.min_len = 10
      component.max_len = 10
      component.max_length = 10
      component.regex = "/^[0-9]{10}$/"
    } else {
      component.min_len = 7
      component.max_len = 15
      component.max_length = 15
      component.regex = "/^[0-9]+$/"
    }
    
    return true
  } catch (error) {
    console.error("Error updating phone validation:", error)
    return false
  }
}

const updatePincodeValidation = (journeySteps, pageId, sectionId, componentId, formControlKey, isIndia) => {
  try {
    const tempPageIndex = journeySteps.pages.findIndex(page => page.pageId === pageId)
    if (tempPageIndex === -1) return false
    
    const tempSectionIndex = journeySteps.pages[tempPageIndex].sections.findIndex(section => section.sectionId === sectionId)
    if (tempSectionIndex === -1) return false
    
    const tempComponentGroupIndex = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(cg => cg.componentId === componentId)
    if (tempComponentGroupIndex === -1) return false
    
    const tempComponentIndex = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(comp => comp.formControlKey === formControlKey)
    if (tempComponentIndex === -1) return false
    
    const component = journeySteps.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]
    
    if (isIndia) {
      component.min_len = 6
      component.max_len = 6
      component.regex = null
      component.__typename = "ComponentCmpTagNumber"
    } else {
      component.min_len = 3
      component.max_len = 9
      component.regex = "/^[a-zA-Z0-9 ]+$/"
      component.__typename = "ComponentCmpTagTextString"
    }
    
    return true
  } catch (error) {
    console.error("Error updating pincode validation:", error)
    return false
  }
}

export default function ComponentTextNumber(props) {

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [journeyState, setJourneyState] = useContext(JourneyContext);
  const [isFocus, setIsFocus] = useState(false)

  const validate = (target) => {
    if (props.data.required) { // required field validation
      // console.log("required")
      if (sectionState.sectionData && ((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey]))) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
              ? (getValueFromJourney(
                journeyState.lookup.required_error,
                props.data.requiredError
              )) : `Error Code Not Found in Strapi`,
          })
        })
        return
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
    if (target.value) {
      // Special validation for pincode outside India - minimum length should be 3
      if (isPincodeField(props.data.formControlKey)) {
        let countryValue = null
        
        // For appointeePincode, check appointeeCountry only when appointeeAddressSameAsLaOthers is "Others"
        if (props.data.formControlKey && props.data.formControlKey.toLowerCase().includes("appointee") && props.data.formControlKey.toLowerCase().includes("pincode")) {
          const addressSameAs = sectionState.sectionData?.["appointeeAddressSameAsLaOthers"]
          if (addressSameAs === "Others") {
            countryValue = sectionState.sectionData?.["appointeeCountry"] || conditionState[`${props.pageId}.${props.sectionId}.appointeeCountry`]
          }
        } else {
          // For other pincode fields
          const countryFields = [
            "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
            "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
            "jointlifePermanentAddressCountry", "eaCountry"
          ]
          // Check sectionState first
          for (const field of countryFields) {
            if (sectionState.sectionData?.[field]) {
              countryValue = sectionState.sectionData[field]
              break
            }
          }
          // Also check conditionState if not found in sectionState
          if (!countryValue) {
            for (const field of countryFields) {
              const conditionKey = Object.keys(conditionState).find(key => key.includes(field))
              if (conditionKey && conditionState[conditionKey]) {
                countryValue = conditionState[conditionKey]
                break
              }
            }
          }
        }
        // If country is not India and pincode length is less than 3
        if (countryValue && countryValue !== "IN" && target.value.length > 0 && target.value.length < 3) {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: "Minimum length should be 3"
            })
          })
          setShowLocalError(true)
          return
        }
      }
      
      if (props.data.min_len) { // min_len validation
        if (target.value.length < props.data.min_len) {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: (getValueFromJourney(
                journeyState.lookup.min_error,
                props.data.min_len_error
              ))
            })
          })
          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
      }
      if (props.data.max_len) { //max length validation
        if (target.value.length > props.data.max_len) {
          // Special handling for pincode - enforce max length based on country
          if (isPincodeField(props.data.formControlKey)) {
            let countryValue = null
            
            // For appointeePincode, check appointeeCountry only when appointeeAddressSameAsLaOthers is "Others"
            if (props.data.formControlKey && props.data.formControlKey.toLowerCase().includes("appointee") && props.data.formControlKey.toLowerCase().includes("pincode")) {
              const addressSameAs = sectionState.sectionData?.["appointeeAddressSameAsLaOthers"]
              if (addressSameAs === "Others") {
                countryValue = sectionState.sectionData?.["appointeeCountry"] || conditionState[`${props.pageId}.${props.sectionId}.appointeeCountry`]
                // If country is India, max length should be 6
                if (countryValue === "IN" && target.value.length > 6) {
                  setErrorState(prev => {
                    return ({
                      ...prev,
                      [props.data.formControlKey]: (getValueFromJourney(
                        journeyState.lookup.max_error,
                        props.data.max_len_error
                      ))
                    })
                  })
                  setShowLocalError(true)
                  return
                }
                // If country is not India, max length should be 9
                if (countryValue && countryValue !== "IN" && target.value.length > 9) {
                  setErrorState(prev => {
                    return ({
                      ...prev,
                      [props.data.formControlKey]: `${(getValueFromJourney(
                        journeyState.lookup.label,
                        props.data.label
                      )) || props.data.label} can maximum be of 9 characters`
                    })
                  })
                  setShowLocalError(true)
                  return
                }
              }
            } else {
              // For other pincode fields
              const countryFields = [
                "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
                "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
                "jointlifePermanentAddressCountry", "eaCountry"
              ]
              // Check sectionState first
              for (const field of countryFields) {
                if (sectionState.sectionData?.[field]) {
                  countryValue = sectionState.sectionData[field]
                  break
                }
              }
              // Also check conditionState if not found in sectionState
              if (!countryValue) {
                for (const field of countryFields) {
                  const conditionKey = Object.keys(conditionState).find(key => key.includes(field))
                  if (conditionKey && conditionState[conditionKey]) {
                    countryValue = conditionState[conditionKey]
                    break
                  }
                }
              }
              // If country is not India, show max length as 9
              if (countryValue && countryValue !== "IN") {
                setErrorState(prev => {
                  return ({
                    ...prev,
                    [props.data.formControlKey]: `${(getValueFromJourney(
                      journeyState.lookup.label,
                      props.data.label
                    )) || props.data.label} can maximum be of 9 characters`
                  })
                })
                setShowLocalError(true)
                return
              }
            }
          }
          
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: (getValueFromJourney(
                journeyState.lookup.max_error,
                props.data.max_len_error
              ))
            })
          })
          setShowLocalError(true)
          return
        }
        else {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
      }
      if (props.data.min_value) {
        let value = parseInt(target.value)
        console.log(typeof (value))
        if (value < props.data.min_value) {
          if (props.data.label) {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: `${(getValueFromJourney(
                    journeyState.lookup.label,
                    props.data.label
                  )) || props.data.label} can't be less than ${props.data.min_value}`,

              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: (getValueFromJourney(
                    journeyState.lookup.min_error,
                    props.data.min_value_error
                  ))

              }
            })
          }
        }
      }
      if (props.data.max_value) {
        let value = parseInt(target.value)
        console.log(typeof (value))
        if (value > props.data.max_value) {
          if (props.data.label) {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: `${(getValueFromJourney(
                    journeyState.lookup.label,
                    props.data.label
                  )) || props.data.label} can't be more than ${props.data.max_value}`,

              }
            })
          } else {
            setErrorState(prev => {
              return {
                ...prev,
                [props.data
                  .formControlKey]: (getValueFromJourney(
                    journeyState.lookup.max_value,
                    props.data.max_value_error
                  ))

              }
            })
          }
        }
      }
      if (props.data.regex) {
        let regex = (props.data.regex.toString())
        let rg = regex.substring(1, regex.lastIndexOf('/'))
        let flags = regex.substring(regex.lastIndexOf('/') + 1)
        let regex_exp = new RegExp(rg, flags)
        if (regex_exp.test(target.value)) {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
        else {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.data.requiredError
                ? (getValueFromJourney(
                  journeyState.lookup.required_error,
                  props.data.regexError
                )) : `Error Code Not Found in Strapi`,
            })
          })
          setShowLocalError(true)
          return
        }
      }
    } else {
      if((props.data.formControlKey === "heightInFeets" || props.data.formControlKey === "heightInInches")){
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "height&weight")
      let tempComponentIndexToChangeCms = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInCms")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeCms]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["heightInCms"]: "",
              ["disableCms"]: false,
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.heightInCms`]: "",
          }
        })
      }
      if(props.data.formControlKey === "heightInCms"){
        let temp = journeyState.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "height&weight")
        let tempComponentIndexToChangeFeet = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInFeets")
        let tempComponentIndexToChangeInches = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInInches")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeFeet]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeInches]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["heightInFeets"]: "",
              ["heightInInches"]: "",
              ["disableInInches"]: false
            },
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.heightInFeets`]: "",
            [`${props.pageId}.${props.sectionId}.heightInInches`]: ""
          }
        })
      }
      console.log("===>12345")
      setErrorState(prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: ""
        })
      })
    }

    if(props.data.formControlKey === "AlternateMobNumber" && target.value && (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" || props.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail") ){
      if(target.value !== sectionState.sectionData?.["contactNumber"]){
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Alternate Mobile Number and Contact Number cannot be same"
          })
        })
        setShowLocalError(true)
        return
      }
    }
    // console.log(errorState)
    return
  }

  useEffect (()=>{
    let temp 
    if(props.sectionId==="SectionFlexiEdgeFillproposalOccupationDetails" && sectionState?.sectionData?.['country']==='AE'){
       temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ODEmployerDetails")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString";
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = null;
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = null;
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = null;


    }
    if(props.sectionId==="SectionFlexiEdgeFillproposalOccupationDetails" && sectionState?.sectionData?.['country']==='IN'){
       temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ODEmployerDetails")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6;
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = 6;
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6;


    }

    if(props.sectionId==="SectionFlexiEdgeFillProposalProposerDetails" && sectionState?.sectionData?.['empcountry']==='IN'){
      temp = journeyState?.journeySteps
     let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
     let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
     let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerdetails")
     let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "emppincode")
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber";
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "M0002";
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0002";
   }

   if(props.sectionId==="SectionFlexiEdgeFillProposalProposerDetails" && sectionState?.sectionData?.['empcountry']!=='IN'){
    temp = journeyState?.journeySteps
   let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
   let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
   let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerdetails")
   let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "emppincode")
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = 9;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString";
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0015";
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018";
 }

    setJourneyState(prev=>{
      return ({
        ...prev,
        journeyState:temp
      })
    })
  },[sectionState?.sectionData?.["country"], sectionState?.sectionData?.['empcountry']])

  useEffect (()=>{
    let temp 
    if(props.sectionId==="SectionFlexiEdgeFillProposalProposerDetails" && sectionState?.sectionData?.['empcountry']==='IN'){
      temp = journeyState?.journeySteps
     let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
     let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
     let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerdetails")
     let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "emppincode")
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6;
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber";
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "E0167";
     temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "E0167";
   }

   if(props.sectionId==="SectionFlexiEdgeFillProposalProposerDetails" && sectionState?.sectionData?.['empcountry']!=='IN'){
    temp = journeyState?.journeySteps
   let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
   let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
   let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerdetails")
   let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "emppincode")
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len"] = 9;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9;
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString";
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0015";
   temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018";
 }

    setJourneyState(prev=>{
      return ({
        ...prev,
        journeySteps:temp
      })
    })
  },[sectionState?.sectionData?.["country"], sectionState?.sectionData?.['empcountry']])


  const checkForPincodes = (target) => {
    if(props.sectionId==="SectionFlexiEdgeFillproposalOccupationDetails" && sectionState?.sectionData?.['country']==='AE'){
      return;
    }
    if (props.data.formControlKey.toLowerCase().includes("pincode") && (target.value && target.value.length === 6)) {
      //general function to set any form control key in section state
      const asyncStateSetter = (pageId, sectionId, componentGroupId, stateFormControlKey, cityComponentId, cityFormControlKey) => {
        let payload = {
          "pincode": target.value
        }
        fetchPincodeDetails(payload)//133001 ,201304
          .then(res => {
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
            let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
            let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroupId)
            let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === stateFormControlKey)
            console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
            if (res && res.pincodeDetails.state) {
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = true;
            }
            else {
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = false;
            }

            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [stateFormControlKey]: res?.pincodeDetails?.state,
                  [cityFormControlKey]: res?.pincodeDetails?.city?.toUpperCase()
                }
              })
            })
            console.log(conditionState, "pincode conditionState")
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.${cityFormControlKey}`]: res?.pincodeDetails?.city?.toUpperCase(),
              }
            })
            if (!res?.pincodeDetails?.city) {
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    [cityFormControlKey]: "OTHERS"
                  }
                })
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  [`${props.pageId}.${props.sectionId}.${cityFormControlKey}`]: "OTHERS",
                }
              })
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          })
          .catch((err) => {
            console.log("errorrrr");
            // This case executes If pincode not valid
            console.log("Please enter valid pincode", err)
            setErrorState(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: `Please enter valid pincode`
              })
            })
            if (props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || props.sectionId === "SectionULIPOccupationDetails" || props.sectionId === "SectionULIPCommunicationAddress" || props.sectionId === "SectionGOPAPersonelDetails" && props.data.formControlKey == "pincode") {
              emptyFormControKeyInState("state")
            } else if (props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode") {
              emptyFormControKeyInState("state")
            } else if (props.sectionId === "residenceDetailsSection" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "PRPincode") {
              emptyFormControKeyInState("PRState")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "pincode") {
              emptyFormControKeyInState("state")
              emptyFormControKeyInState("city")
              emptyFormControKeyInState("commCity")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "pincodePermanent") {
              emptyFormControKeyInState("permanentState")
              emptyFormControKeyInState("cityPermanent")
              emptyFormControKeyInState("permCityName")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && props.data.formControlKey === "pincode") {
              emptyFormControKeyInState("state")
              emptyFormControKeyInState("cityemp")
              emptyFormControKeyInState("cityNameEmp")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "emppincode") {
              emptyFormControKeyInState("empstate")
              emptyFormControKeyInState("empcity")
              emptyFormControKeyInState("cityNameemp")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "pincode") {
              emptyFormControKeyInState("state")
              emptyFormControKeyInState("cityCommProp")
              emptyFormControKeyInState("cityNameCommProp")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "proposerPincode") {
              emptyFormControKeyInState("proposerState")
              emptyFormControKeyInState("proposerCity")
              emptyFormControKeyInState("cityNamePerm")
            }
            else if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey === "nomineePincode") {
              emptyFormControKeyInState("stateNominee")
              emptyFormControKeyInState("cityNominee")
              emptyFormControKeyInState("cityTextNominee")
            }
            else if (props.sectionId === "FlexiEdgeFillProposalAppointeeSection" && props.data.formControlKey === "appointeePincode") {
              emptyFormControKeyInState("appointeeState")
              emptyFormControKeyInState("cityAppointee")
              emptyFormControKeyInState("cityNameAppointee")
            }
            else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
              emptyFormControKeyInState("GOPAstate")
              emptyFormControKeyInState("GopaCity")
              emptyFormControKeyInState("citytextgsp")
              functionToEmptyStateAndUnfreeze()
            }
            else if (props.sectionId === "proposerCommonResidenceAndOccupation" && props.data.formControlKey === "proposerPincode") {
              emptyFormControKeyInState("proposerState")
              emptyFormControKeyInState("ProposerCity")
              emptyFormControKeyInState("proposerCityOther")
              functionToEmptyStateAndUnfreeze()
            }

            else if (props.sectionId === "sectionGOPAJointLifeQuestionnaire" && props.data.formControlKey === "jointlifeCommunicationPincode") {
              emptyFormControKeyInState("GOPAstate")
              // emptyFormControKeyInState("jointlifeCommunicationCountry")
              emptyFormControKeyInState("jointlifeCommunicationCity")
              functionToEmptyStateAndUnfreeze()
            }
            else if (props.sectionId === "sectionGOPAJointLifeQuestionnaire" && props.data.formControlKey === "jointlifePermanentAddressPincode") {
              emptyFormControKeyInState("jointlifePermanentAddressState")
              emptyFormControKeyInState("jointlifePermanentAddressCity")
              // emptyFormControKeyInState("jointlifeCommunicationCity")
              functionToEmptyStateAndUnfreeze()
            }
            console.log(props.sectionId, "iddd")
            setShowLocalError(true)
            return
          })
      }
      const emptyFormControKeyInState = (formControlKeyToEmpty) => {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKeyToEmpty]: ""
            }
          })
        })
      }

      const unfreezeField = (pageId, sectionId, componentGroupId, stateFormControlKey) => {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroupId)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === stateFormControlKey)
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "dfefd")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]['freeze'] = false;
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }

      const functionToEmptyStateAndUnfreeze = () => {
        let fillProposalPageId
        let fillcalculatePageId
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          fillcalculatePageId = "calculatePremiumPage"
          fillProposalPageId = "fillProposalForm"
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          fillcalculatePageId = "PageISelect360CalculatePremium"
          fillProposalPageId = "pageISelect360FillProposalForm"
        } else if (props.journeyIdFromStrapi == "FlexiEdgeJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
        } else if (props.journeyIdFromStrapi == "titaniumPlusJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
        } else if (props.journeyIdFromStrapi == "FutureDollarGiftCityJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageFutureDollarGiftCityCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "guaranteedSavingsOption") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedSavingsCalculatePremium"
        } else if (props.journeyIdFromStrapi == "guaranteedIncomeAdvantage") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
        } else if (props.journeyIdFromStrapi == "GuarateedOnePayJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedOnePayCalculatePremium"
        } else if (props.journeyIdFromStrapi === "insureSmart") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageInsureSmartCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "moneyBackAdvantage") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageMoneyBackCalculatePremium"
        } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageJeevenNiveshCalculatePremium"
        } else if (props.journeyIdFromStrapi === "invest4GJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageInvest4GCalculateFundValue"
        } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageSmartJuniorCalculatePremium"
        } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageSecureBhavishyaCalculatePremium"
        } else if (props.journeyIdFromStrapi === "guaranteedFortuneJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedFortuneCalculatePremium"
        } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedFutureCalculatePremium"
        } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedIncome4LifeCalculatePremium"
        } else if (props.journeyIdFromStrapi === "GAINjourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "GAINcalculatePremiumPage"
        }
        if (props.sectionId === "CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        } else if (props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillcalculatePageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state")
        }
        else if (props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "residenceDetailsSection", "state", "state")
        }
        else if (props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "PRPincode") {
          emptyFormControKeyInState("PRState")
          unfreezeField(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalCommunicationAddress", "state", "state")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && props.data.formControlKey === "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillproposalOccupationDetails", "ODEmployerDetails", "state")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "emppincode") {
          emptyFormControKeyInState("empstate")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "employerdetails", "empstate")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "pincode") {
          emptyFormControKeyInState("state")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "communicationaddress", "state")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "proposerPincode") {
          emptyFormControKeyInState("proposerState")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "communicationAddressCondition", "proposerState")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey === "nomineePincode") {
          emptyFormControKeyInState("stateNominee")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalNomineeDetails", "AddressComponentNominee", "stateNominee")
        }
        else if (props.sectionId === "FlexiEdgeFillProposalAppointeeSection" && props.data.formControlKey === "appointeePincode") {
          emptyFormControKeyInState("appointeeState")
          unfreezeField(fillProposalPageId, "SectionFlexiEdgeFillProposalNomineeDetails", "nomineeAgeCondition", "appointeeState")
        }
        else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
          emptyFormControKeyInState("GOPAstate")
          unfreezeField(fillcalculatePageId, "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate")
        }
        else if (props.sectionId === "proposerCommonResidenceAndOccupation" && props.data.formControlKey === "proposerPincode") {
          emptyFormControKeyInState("proposerState")
          unfreezeField(fillcalculatePageId, "proposerCommonResidenceAndOccupation", "proposerState", "proposerState")
        }

        /* The below commented code will help in making above conditions for POS and ULIP Journey*/

        // if(props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" || props.sectionId === "SectionULIPOccupationDetails" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "pincode"){
        //   emptyFormControKeyInState("state")
        //   asyncStateSetter(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        // }else if(props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode"){
        //   emptyFormControKeyInState("state")
        // }else if(props.sectionId === "residenceDetailsSection" || props.sectionId === "SectionULIPCommunicationAddress" && props.data.formControlKey == "PRPincode"){
        //   emptyFormControKeyInState("PRState")
        // }
        // setShowLocalError(true)
      }

      const checkNegativePincode = () => {
        const negativePincodes = lookup["negativePincodes"]
        let index = negativePincodes.findIndex(element => element === target.value)
        if (index !== -1) {
          let conditionStateValueEducationQualification
          let conditionStateValueAnnualIncome
          if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
            conditionStateValueEducationQualification = conditionState["calculatePremiumPage.CPPersonalDetailsSection.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["calculatePremiumPage.CPPersonalDetailsSection.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
            conditionStateValueEducationQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.AnnualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
            conditionStateValueEducationQualification = conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.educationalQualification"]
            conditionStateValueAnnualIncome = conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.annualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "insureSmart") {
            conditionStateValueEducationQualification = conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
            conditionStateValueEducationQualification = conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
            conditionStateValueEducationQualification = conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
            conditionStateValueEducationQualification = conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAannualIncome"]
          } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
            conditionStateValueEducationQualification = conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
            conditionStateValueEducationQualification = conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
            conditionStateValueEducationQualification = conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.GOPAannualIncome"]
          }
          else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
            conditionStateValueEducationQualification = conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAeducationQualification"]
            conditionStateValueAnnualIncome = conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAannualIncome"]
          }
          if (!["1", "2"].includes(conditionStateValueEducationQualification)) {
            setErrorState(prev => {
              return ({
                ...prev,
                [props.data.formControlKey]: `This Pincode is not serviceable`
              })
            })
            functionToEmptyStateAndUnfreeze()
            return true
          } else {
            if (conditionStateValueAnnualIncome < 500000) {
              setErrorState(prev => {
                return ({
                  ...prev,
                  [props.data.formControlKey]: `This Pincode is not serviceable`
                })
              })
              functionToEmptyStateAndUnfreeze()
              return true

            } else {
              return false
            }
          }
        } else {
          return false
        }
      }

      const pincodeApiCallsAndStateFillingMultipeJourney = () => {
        let fillProposalPageId
        let fillcalculatePageId
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          fillcalculatePageId = "calculatePremiumPage"
          fillProposalPageId = "fillProposalForm"
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          fillcalculatePageId = "PageISelect360CalculatePremium"
          fillProposalPageId = "pageISelect360FillProposalForm"
        } else if (props.journeyIdFromStrapi == "FlexiEdgeJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageFlexiEdgeCalculatePremium"
        } else if (props.journeyIdFromStrapi == "titaniumPlusJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageTitaniumPlusCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "FutureDollarGiftCityJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageFutureDollarGiftCityCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "guaranteedSavingsOption") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedSavingsCalculatePremium"
        } else if (props.journeyIdFromStrapi == "GuarateedOnePayJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedOnePayCalculatePremium"
        } else if (props.journeyIdFromStrapi == "insureSmart") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageInsureSmartCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "guaranteedIncomeAdvantage") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
        } else if (props.journeyIdFromStrapi == "jeevanNivesh") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageJeevenNiveshCalculatePremium"
        } else if (props.journeyIdFromStrapi == "moneyBackAdvantage") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageMoneyBackCalculatePremium"
        } else if (props.journeyIdFromStrapi == "invest4GJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageInvest4GCalculateFundValue"
        } else if (props.journeyIdFromStrapi == "smartJuniorPlan") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageSmartJuniorCalculatePremium"
        } else if (props.journeyIdFromStrapi == "secureBhavishyaJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageSecureBhavishyaCalculatePremium"
        } else if (props.journeyIdFromStrapi == "guaranteedFortuneJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedFortuneCalculatePremium"
        } else if (props.journeyIdFromStrapi == "guaranteedFutureJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedFutureCalculatePremium"
        } else if (props.journeyIdFromStrapi == "guaranteedIncome4LifeJourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "PageGuaranteedIncome4LifeCalculatePremium"
        } else if (props.journeyIdFromStrapi == "GAINjourney") {
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          fillcalculatePageId = "GAINcalculatePremiumPage"
        }
        // For dynamic pageID
        if (props.sectionId === "CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode") {
          asyncStateSetter(fillcalculatePageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state")
        }
        else if (props.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props.data.formControlKey == "pincode") {
          asyncStateSetter(fillcalculatePageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state")
        }
        else if (props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "pincode") {
          asyncStateSetter(fillProposalPageId, "residenceDetailsSection", "state", "state")
        }
        else if (props.sectionId === "residenceDetailsSection" && props.data.formControlKey == "PRPincode") {
          asyncStateSetter(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState")
        }
        // For GSP
        else if (props.sectionId === "SectionPOSOccupationDetails" && props.data.formControlKey == "pincode") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSOccupationDetails", "officeState-MD-4-Order-12", "state")
        }
        else if (props.sectionId === "SectionPOSCommunicationAddress" && props.data.formControlKey == "pincode") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSCommunicationAddress", "state", "state")
        } else if (props.sectionId === "SectionPOSCommunicationAddress" && props.data.formControlKey == "PRPincode") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSCommunicationAddress", "permanentResidentialDetailsWithLandMark-MD-12-Order", "PRState")
        }
        else if (props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "employerPincode") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "employerLocation", "employerState")
        }
        else if (props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "pincode") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "communicationAddress", "state")
        }
        else if (props.sectionId === "SectionPOSProposerDetails" && props.data.formControlKey == "pincodePermanent") {
          asyncStateSetter("PagePOSFillProposalForm", "SectionPOSProposerDetails", "permanentAddress", "statePermanent")
        }
        //for FlexiEdge
        else if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "pincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalCommunicationAddress", "state", "state", "city", "city")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "pincodePermanent") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalCommunicationAddress", "isYourCurrentResentialSameCondition", "permanentState", "isYourCurrentResentialSameCondition", "cityPermanent")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" && props.data.formControlKey === "pincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillproposalOccupationDetails", "ODEmployerDetails", "state", "ODEmployerDetails", "cityemp")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "emppincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "employerdetails", "empstate", "employerdetails", "empcity")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "pincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "communicationaddress", "state", "communicationaddress", "cityCommProp")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "proposerPincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalProposerDetails", "communicationAddressCondition", "proposerState", "communicationAddressCondition", "proposerCity")
        }
        else if (props.sectionId === "SectionFlexiEdgeResidenceandOccupationDetails" && props.data.formControlKey === "pincode") {
          asyncStateSetter(fillcalculatePageId, "SectionFlexiEdgeResidenceandOccupationDetails", "flexistate", "state", "Flexicityofbirth", "cityOfBirth")
        }
        else if (props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails" && props.data.formControlKey === "nomineePincode") {
          asyncStateSetter(fillProposalPageId, "SectionFlexiEdgeFillProposalNomineeDetails", "AddressComponentNominee", "stateNominee", "AddressComponentNominee", "cityNominee")
        }
        else if (props.sectionId === "FlexiEdgeFillProposalAppointeeSection" && props.data.formControlKey === "appointeePincode") {
          asyncStateSetter(fillProposalPageId, "FlexiEdgeFillProposalAppointeeSection", "nomineeAgeCondition", "appointeeState", "nomineeAgeCondition", "cityAppointee")
        }
        //For titaniumPlus
        else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "pincode") {
          asyncStateSetter(fillcalculatePageId, "SectionCommonResidenceAndOccupation", "CFState", "state", "titaniumCity", "cityOfBirth")
        }
        //For Gsp, GIAP, GOPA, JeevanNivesh, MoneyBack, Invest 4G, insure smart
        else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
          asyncStateSetter(fillcalculatePageId, "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        }
        // // FOR GIAP
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter(fillcalculatePageId, "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        //For GOPA
        // PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageGuaranteedOnePayCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        else if (props.sectionId === "sectionGOPAJointLifeQuestionnaire" && props.data.formControlKey === "jointlifeCommunicationPincode") {
          asyncStateSetter("PageFlexiEdgeFillProposalForm", "sectionGOPAJointLifeQuestionnaire", "jointlifeCommunicationStateOrder-13", "jointlifeCommunicationState", "jointlifeCommunicationCity", "jointlifeCommunicationCity")
        }
        else if (props.sectionId === "sectionGOPAJointLifeQuestionnaire" && props.data.formControlKey === "jointlifePermanentAddressPincode") {
          asyncStateSetter("PageFlexiEdgeFillProposalForm", "sectionGOPAJointLifeQuestionnaire", "jointlifePermanentAddressCountry_stateOrder-19", "jointlifePermanentAddressState", "jointlifePermanentAddressCity", "jointlifePermanentAddressCity")
        }
        else if (props.sectionId === "sectionGOPAJointLifeQuestionnaire" && props.data.formControlKey === "eaPincode") {
          asyncStateSetter("PageFlexiEdgeFillProposalForm", "sectionGOPAJointLifeQuestionnaire", "JointLifeEAAddressLine1-order-61", "eaState", "eaCity", "eaCity")
        }
        // FOR InsureSmart
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageInsureSmartCalculateFundValue", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR JeevanNivesh
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageJeevenNiveshCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR MoneyBack
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageMoneyBackCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR invest 4g
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageInvest4GCalculateFundValue", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR Smart Junior
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageSmartJuniorCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR Secure Bhavishya
        // else if (props.sectionId === "SectionCommonResidenceAndOccupation" && props.data.formControlKey === "GOPApincode") {
        //   asyncStateSetter("PageSecureBhavishyaCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        // }
        // FOR Guaranteed Fortune
        else if (props.sectionId === "SectionGuaranteedFortunePersonelDetails" && props.data.formControlKey === "GOPApincode") {
          asyncStateSetter("PageGuaranteedFortuneCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        }
        // FOR Guaranteed Income for Life
        else if (props.sectionId === "SectionGuaranteedIncome4LifePersonelDetails" && props.data.formControlKey === "GOPApincode") {
          asyncStateSetter("PageGuaranteedIncome4LifeCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate", "GOPAstate", "GopaCity", "GopaCity")
        }
        else if (props.sectionId === "proposerCommonResidenceAndOccupation" && props.data.formControlKey === "proposerPincode") {
          asyncStateSetter(fillcalculatePageId, "proposerCommonResidenceAndOccupation", "proposerState", "proposerState", "ProposerCity", "ProposerCity")
        }
      }

      //checking for incorrect pincode
      if (target.value == "000000") {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: `This Pincode is incorrect`
          })
        })
        functionToEmptyStateAndUnfreeze()
        return
      }

      let sectionNegativePincodeKeys = sectionKeysToCheckNegativePincode[props.sectionId]
      if (sectionNegativePincodeKeys && sectionNegativePincodeKeys.length && sectionNegativePincodeKeys.includes(props.data.formControlKey)) {
        let isPincodeNegative = checkNegativePincode()
        pincodeApiCallsAndStateFillingMultipeJourney()
      } else {
        pincodeApiCallsAndStateFillingMultipeJourney()
      }
    }
  }

  const checkAlternateContact = (target) => {
    if (props.data.formControlKey.toLowerCase().includes("alternatemobnumber") && props.sectionId === "personalDetailsSection") {
      if (target.value === sectionState.sectionData["contactNumber"] && target.value?.length === 10) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Mobile number and Alternate Mobile number should not be same"
          })
        })
      } else if (target.value?.length === 10) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    } else if (props.data.formControlKey.toLowerCase().includes("alternatemobnumber") && props.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail") {
      if (target.value === sectionState.sectionData["contactNumber"] && target.value?.length === 10) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Mobile number and Alternate Mobile number should not be same"
          })
        })
      } 
    } else if (props.data.formControlKey.toLowerCase().includes("alternatemobnumber") && props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails") {
      if (target.value === sectionState.sectionData["contactNumber"] && target.value?.length === 10) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Mobile number and Alternate Mobile number should not be same"
          })
        })
      }
    }
  }

  const checkPercentage = (target) => {
    if (props.data.formControlKey === "OccupationalOilNaturalQPhysicalDuties" && props.sectionId === "OccupationalQuestionnaireSectionOil") {
      // console.log("====>inside1", sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] )
      if (sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] > 100 || sectionState.sectionData["OccupationalOilNaturalQPhysicalDuties"] < 0) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between O to 100"
          })
        })
        setShowLocalError(true)
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    } else if (props.data.formControlKey === "MerchantMarineQNaturePhysicalNatureDuties" && props.sectionId === "OccupationalQuestionnaireSectionMarine") {
      console.log("====>inside1", sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"])
      if (sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] > 100 || sectionState.sectionData["MerchantMarineQNaturePhysicalNatureDuties"] < 0) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between O to 100"
          })
        })
        setShowLocalError(true)
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    } else if (props.data.formControlKey === "MiningQuestionnairePhysicalNatureDuties" && props.sectionId === "OccupationalQuestionnaireSectionMining") {
      console.log("====>inside1", sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"])
      if (sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] > 100 || sectionState.sectionData["MiningQuestionnairePhysicalNatureDuties"] < 0) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Percentage Should Be Between O to 100"
          })
        })
        setShowLocalError(true)
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
  }

  const height = (target) => {
    if(target.value){
      if (sectionState.sectionData?.["heightInFeets"] && sectionState.sectionData?.["heightInInches"] && !sectionState.sectionData?.["disableInInches"]) {
        let heightinCms = feetToCms(sectionState.sectionData?.["heightInFeets"], sectionState.sectionData?.["heightInInches"])
        console.log(heightinCms)
        if (heightinCms) {
          let temp = journeyState.journeySteps
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails")
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "height&weight")
          let tempComponentIndexToChangeCms = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInCms")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeCms]["disabled"] = true
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["heightInCms"]: heightinCms,
                ["disableCms"]: true,
              },
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.heightInCms`]: heightinCms,
            }
          })
        }
      }
      else if(sectionState.sectionData?.["heightInCms"] && !sectionState.sectionData?.["disableCms"]){
        let cms = sectionState.sectionData?.["heightInCms"]
        let feet = Math.floor(cms / 30.48)
        let inches =  Math.round((cms / 30.48 - feet) * 12)
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
            let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails")
            let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "height&weight")
            let tempComponentIndexToChangeFeet = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInFeets")
            let tempComponentIndexToChangeInches = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInInches")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeFeet]["disabled"] = true
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeInches]["disabled"] = true
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["heightInFeets"]: String(feet),
                  ["heightInInches"]: String(inches),
                  ["disableInInches"]: true
                },
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                [`${props.pageId}.${props.sectionId}.heightInFeets`]:feet,
                [`${props.pageId}.${props.sectionId}.heightInInches`]: inches
              }
            })
      }
    }  
  }

  useEffect(() => {
    validate({ value: sectionState.sectionData?.[props.data.formControlKey] ?? "" })
  }, [sectionState.sectionData?.[props.data.formControlKey]])

  useEffect(() => {
    if(sectionState.sectionData?.[props.data.formControlKey]){
      dataMask({
        value: sectionState.sectionData?.[props.data.formControlKey] ?? "",
      },"mask")
    }
  },[sectionState?.sectionFirstPass, sectionState?.sectionId])

  useEffect(() => {
    if(props.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails" && !sectionState.sectionData?.["heightInCms"] && !sectionState.sectionData?.["heightInFeets"] && !sectionState.sectionData?.["heightInInches"]){
      let temp = journeyState.journeySteps
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalHealth&LifestyleDetails")
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "height&weight")
          let tempComponentIndexToChangeCms = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInCms")
          let tempComponentIndexToChangeFeet = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInFeets")
          let tempComponentIndexToChangeInches = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "heightInInches")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeFeet]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeInches]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeCms]["disabled"] = false

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
    }
  }, [sectionState?.sectionId])

  useEffect(() => {
    if (sectionState.sectionData?.["otherInsureAnutizedAmount"] && sectionState.sectionData?.["insureAnutizedAmount"]) {
      var value1 = parseInt(sectionState.sectionData?.["otherInsureAnutizedAmount"]) + parseInt(sectionState.sectionData?.["insureAnutizedAmount"])
      if (value1 > 100) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: "Please enter correct values"
          })
        })
        setShowLocalError(true)
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
        setShowLocalError(true)
      }
    }

  }, [sectionState.sectionData?.["otherInsureAnutizedAmount"], sectionState.sectionData?.["insureAnutizedAmount"]])

  // Universal Phone Number Validation - Updates ALL phone fields across ALL pages
  useEffect(() => {
    let temp = journeyState.journeySteps
    let updated = false
    
    // Iterate through all pages
    temp.pages.forEach((page) => {
      // Iterate through all sections
      page.sections.forEach((section) => {
        // Iterate through all component groups
        section.component_groups.forEach((componentGroup) => {
          // Iterate through all components
          componentGroup.components.forEach((component) => {
            if (isPhoneNumberField(component.formControlKey)) {
              let contactCountryCode = null
              let isNomineePhone = false
              
              // Check if this is a nominee-related phone field
              if (component.formControlKey && (component.formControlKey.toLowerCase().includes("nominee") || component.formControlKey.toLowerCase().includes("contactnominee"))) {
                isNomineePhone = true
                // Check countryCodeNominee first, then nomineeCountryCode
                contactCountryCode = sectionState.sectionData?.["countryCodeNominee"] || 
                                     sectionState.sectionData?.["nomineeCountryCode"] ||
                                     conditionState[`${page.pageId}.${section.sectionId}.countryCodeNominee`] ||
                                     conditionState[`${page.pageId}.${section.sectionId}.nomineeCountryCode`]
              } else {
                // For other phone fields, use contactCountryCode
                contactCountryCode = sectionState.sectionData?.["contactCountryCode"] ||
                                     conditionState[`${page.pageId}.${section.sectionId}.contactCountryCode`]
              }
              
              if (!contactCountryCode) return
              
              const isIndia = contactCountryCode === "+91"
              
              // Update validation based on country code
              const tempPageIndex = temp.pages.findIndex(p => p.pageId === page.pageId)
              if (tempPageIndex === -1) return
              
              const tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(s => s.sectionId === section.sectionId)
              if (tempSectionIndex === -1) return
              
              const tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(cg => cg.componentId === componentGroup.componentId)
              if (tempComponentGroupIndex === -1) return
              
              const tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(comp => comp.formControlKey === component.formControlKey)
              if (tempComponentIndex === -1) return
              
              const comp = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]
              
              if (isIndia) {
                // For India, use AlphaWealth pattern
                if (isNomineePhone) {
                  comp.min_len = 10
                  comp.max_len = 10
                  comp.max_length = 10
                  comp.regex = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
                  comp.regexError = "E168"
                } else {
                  comp.min_len = 10
                  comp.max_len = 10
                  comp.max_length = 10
                  comp.regex = "/^[0-9]{10}$/"
                }
              } else {
                // For outside India, use AlphaWealth pattern
                if (isNomineePhone) {
                  comp.min_len = 7
                  comp.max_len = 15
                  comp.max_length = 15
                  comp.regex = null
                  comp.regexError = null
                } else {
                  comp.min_len = 7
                  comp.max_len = 15
                  comp.max_length = 15
                  comp.regex = "/^[0-9]+$/"
                }
              }
              updated = true
            }
          })
        })
      })
    })
    
    if (updated) {
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [
    sectionState.sectionData?.["contactCountryCode"],
    sectionState.sectionData?.["countryCodeNominee"],
    sectionState.sectionData?.["nomineeCountryCode"]
  ])

  // ContactNoResidence Validation based on mobileNumberResidence (AlphaWealth pattern)
  useEffect(() => {
    // Get mobileNumberResidence from sectionState or conditionState
    let mobileNumberResidence = sectionState.sectionData?.["mobileNumberResidence"]
    
    // Also check conditionState
    if (!mobileNumberResidence) {
      const conditionKey = Object.keys(conditionState).find(key => key.includes("mobileNumberResidence"))
      if (conditionKey && conditionState[conditionKey]) {
        mobileNumberResidence = conditionState[conditionKey]
      }
    }
    
    if (!mobileNumberResidence) return
    
    const isIndia = mobileNumberResidence === "+91"
    let temp = journeyState.journeySteps
    let updated = false
    
    // Iterate through all pages to find contactNoResidence field
    temp.pages.forEach((page) => {
      page.sections.forEach((section) => {
        section.component_groups.forEach((componentGroup) => {
          componentGroup.components.forEach((component) => {
            if (component.formControlKey === "contactNoResidence") {
              const tempPageIndex = temp.pages.findIndex(p => p.pageId === page.pageId)
              if (tempPageIndex === -1) return
              
              const tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(s => s.sectionId === section.sectionId)
              if (tempSectionIndex === -1) return
              
              const tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(cg => cg.componentId === componentGroup.componentId)
              if (tempComponentGroupIndex === -1) return
              
              const tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(comp => comp.formControlKey === "contactNoResidence")
              if (tempComponentIndex === -1) return
              
              const comp = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]
              
              if (isIndia && comp.formControlKey !== "contactNoResidence" && comp.formControlKey !== "contactNoproposerResidence" ) {
                // For India: min_len = 10, max_len = 10, regex = "/^[6-9][0-9]{9}$/"
                comp.min_len = 10
                comp.max_len = 10
                comp.max_length = 10
                comp.regex = "/^[6-9][0-9]{9}$/"
              } else {
                // For outside India: min_len = 7, max_len = 15, regex = "/^[0-9]+$/"
                comp.min_len = 7
                comp.max_len = 15
                comp.max_length = 15
                comp.regex = "/^[0-9]+$/"
              }
              updated = true
            }
          })
        })
      })
    })
    
    if (updated) {
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [
    sectionState.sectionData?.["mobileNumberResidence"]
  ])

  // Universal Pincode Validation - Updates ALL pincode fields across ALL pages
  useEffect(() => {
    // Get all possible country fields from sectionState
    const countryFields = [
      "country", "countryofbirth", "proposerCountry", "currentCountryofResidence",
      "GIFTcountry", "countryGiftCity", "jointlifeCommunicationCountry",
      "jointlifePermanentAddressCountry", "eaCountry"
    ]
    
    let countryValue = null
    let countryFieldName = null
    
    // Find the first country field that has a value
    for (const field of countryFields) {
      if (sectionState.sectionData?.[field]) {
        countryValue = sectionState.sectionData[field]
        countryFieldName = field
        break
      }
    }
    
    // Also check conditionState for country fields
    if (!countryValue) {
      for (const field of countryFields) {
        const conditionKey = Object.keys(conditionState).find(key => key.includes(field))
        if (conditionKey && conditionState[conditionKey]) {
          countryValue = conditionState[conditionKey]
          countryFieldName = field
          break
        }
      }
    }
    
    if (!countryValue) return
    
    const isIndia = countryValue === "IN"
    let temp = journeyState.journeySteps
    let updated = false
    
    // Iterate through all pages
    temp.pages.forEach((page) => {
      // Iterate through all sections
      page.sections.forEach((section) => {
        // Iterate through all component groups
        section.component_groups.forEach((componentGroup) => {
          // Iterate through all components
          componentGroup.components.forEach((component) => {
            if (isPincodeField(component.formControlKey)) {
              // For appointeePincode, check appointeeCountry only when appointeeAddressSameAsLaOthers is "Others"
              if (component.formControlKey && component.formControlKey.toLowerCase().includes("appointee") && component.formControlKey.toLowerCase().includes("pincode")) {
                const addressSameAs = sectionState.sectionData?.["appointeeAddressSameAsLaOthers"]
                if (addressSameAs === "Others") {
                  const appointeeCountry = sectionState.sectionData?.["appointeeCountry"] || conditionState[`${page.pageId}.${section.sectionId}.appointeeCountry`]
                  if (appointeeCountry) {
                    const isIndiaAppointee = appointeeCountry === "IN"
                    if (updatePincodeValidation(temp, page.pageId, section.sectionId, componentGroup.componentId, component.formControlKey, isIndiaAppointee)) {
                      updated = true
                    }
                  }
                }
              } else {
                // For other pincode fields, use section-specific country or global country
                const sectionCountryField = getCountryFieldForSection(section.sectionId, component.formControlKey, sectionState.sectionData)
                let sectionCountryValue = sectionState.sectionData?.[sectionCountryField]
                
                // Also check conditionState for section country
                if (!sectionCountryValue) {
                  const conditionKey = Object.keys(conditionState).find(key => key.includes(sectionCountryField))
                  if (conditionKey && conditionState[conditionKey]) {
                    sectionCountryValue = conditionState[conditionKey]
                  }
                }
                
                // If section has its own country field, use it; otherwise use the global one
                const useSectionCountry = sectionCountryValue !== undefined && sectionCountryValue !== null && sectionCountryValue !== ""
                const finalCountryValue = useSectionCountry ? sectionCountryValue : countryValue
                const finalIsIndia = finalCountryValue === "IN"
                
                if (updatePincodeValidation(temp, page.pageId, section.sectionId, componentGroup.componentId, component.formControlKey, finalIsIndia)) {
                  updated = true
                }
              }
            }
          })
        })
      })
    })
    
    if (updated) {
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [
    sectionState.sectionData?.["country"],
    sectionState.sectionData?.["countryofbirth"],
    sectionState.sectionData?.["proposerCountry"],
    sectionState.sectionData?.["currentCountryofResidence"],
    sectionState.sectionData?.["GIFTcountry"],
    sectionState.sectionData?.["countryGiftCity"],
    sectionState.sectionData?.["jointlifeCommunicationCountry"],
    sectionState.sectionData?.["jointlifePermanentAddressCountry"],
    sectionState.sectionData?.["eaCountry"],
    sectionState.sectionData?.["appointeeCountry"],
    sectionState.sectionData?.["appointeeAddressSameAsLaOthers"]
  ])

  const dataMask = (target, name) => {
    let maskValue
    if(name === "mask"){
    if(target.value?.length > 0 && props.data.maskType === "number"){
        let mask = target.value.slice(0,5)
        maskValue = `${mask}XXXXX`
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.maskedKey]: maskValue
            }
          })
        })
      } else if(target.value?.length > 0 && props.data.maskType === "string"){
        maskValue = target.value.slice(0, 5) + "*****" 
        setSectionState(prev => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.maskedKey]: maskValue
          }
        })
      })
      }
    } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.maskedKey]: sectionState?.sectionData[props.data.formControlKey],
              }
            })
          })
        }
      }

  const handleChange = ({ target }) => {
    setIsFocus(true)
    if (!isNaN(target.value)) {
      console.info(props.data.formControlKey)

      if (sectionState.sectionId === props.sectionId) {
        setSectionState((prev) => {
          return (
            {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: target.value,
                [props.data.maskedKey]: target.value
              }
            }
          )
        })
      } else {
        setSectionState((prev) => {
          return (
            {
              ...prev,
              sectionId: props.sectionId,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: target.value,
                [props.data.maskedKey]: target.value
              }
            }
          )
        })
      }
      validate(target)
    }
    //console.log(sectionState, "section state")
  }

  useEffect(() => {
    if (props.sectionId === "FDsuccessfullPaymentDetails" && props.data.formControlKey === "amount" && conditionState["PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInstallmentPremium"]){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "amount" : conditionState["PageFutureDollarGiftCityCalculateFundValue.FutureDollarGiftCityInvestmentDetailsSection.FutureDollarInstallmentPremium"]
          }
        }
      })
    }
  }, [])

  // will improve this code later
  useEffect(() => {
    if (props.data.formControlKey === "contactNo" && sectionState.sectionData["contactNo"] && !isFocus) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "numberMask": sectionState.sectionData?.["contactNo"]?.slice(0, 5) + "XXXXX"
          }
        }
      })
    }
  
    if (props.data.formControlKey === "contactNoResidence" && sectionState.sectionData["contactNoResidence"] && !isFocus) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "numberMaskResidence": sectionState.sectionData?.["contactNoResidence"]?.slice(0, 5) + "XXXXX"
          }
        }
      })
    }

    if (props.data.formControlKey === "contactNoproposer" && sectionState.sectionData["contactNoproposer"] && !isFocus) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "contactNoproposerMask": sectionState.sectionData?.["contactNoproposer"]?.slice(0, 5) + "XXXXX"
          }
        }
      })
    }

    if (props.data.formControlKey === "contactNoproposerResidence" && sectionState.sectionData["contactNoproposerResidence"] && !isFocus) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "contactNoproposerMaskResidence": sectionState.sectionData?.["contactNoproposerResidence"]?.slice(0, 5) + "XXXXX"
          }
        }
      })
    }

  }, [
    sectionState.sectionData["contactNo"],
    sectionState.sectionData["contactNoResidence"],
    sectionState.sectionData["contactNoproposer"],
    sectionState.sectionData["contactNoproposerResidence"],
  ])
  

  return (
    <>
      <style>{
        `input[type=number]::-webkit-inner-spin-button, 
      input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          margin: 0; 

      }`
      }
      </style>
      <NumberContainer channel={props.channel} className={`form-group input-container ${props.data.disabled ? 'disable-input' : ''}`} >
        <label htmlFor={props.data.label} className={`input-label ${props.data.label ? '' : 'no-label-number'} `} >{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</label>
        <input
          className={"form-control " + (isIE ? 'IELineHeight' : '')}
          // className={`form-control`}
          type={props.data.type}
          placeholder={(getValueFromJourney(
            journeyState.lookup.placeholder,
            props.data.placeholder
          )) || props.data.placeholder}
          name={+Date.now()}
          required={props.data.required}
          disabled={props.data.disabled}
          onChange={handleChange}
          onClick={(e) => {
            setIsFocus(true)
            props.data.isMasked && dataMask(e.target,"nonMask")
          }}
          autoComplete="new-password"
          value={props.data.isMasked ? sectionState.sectionData?.[props.data.maskedKey]
            : (sectionState.sectionData && sectionState.sectionData[props.data.formControlKey]) ? sectionState.sectionData[props.data.formControlKey] : ""}
          onBlur={(e) => {
            setIsFocus(true)
            checkForPincodes(e.target)
            checkAlternateContact(e.target)
            height(e.target)
            checkPercentage(e.target)
            props.data.isMasked && dataMask(e.target,"mask")
            props.saveApplicationAndCallBi &&
              props.saveApplicationAndCallBi(props.data.formControlKey, e.target.value)
          }}
          maxLength={props.data.max_len}
        ></input>
        {
          props?.data?.formControlKey === "eiaNumber" ?
            (
              <span className="input-error2">{(props.showError || showLocalError) && errorState[props.data.formControlKey]}
              </span>)
            : (sectionKeysToCheckNegativePincode[props.sectionId] && sectionKeysToCheckNegativePincode[props.sectionId].length && sectionKeysToCheckNegativePincode[props.sectionId].includes(props.data.formControlKey) && errorState[props.data.formControlKey] === "This Pincode is not serviceable")
              ? <span></span>
              :
              (
                <span className="input-error2">{(props.showError || showLocalError) && errorState[props.data.formControlKey]}
                </span>
              )
        }
      </NumberContainer>

    </>
  )
}
